export default __webpack_public_path__ + "static/aquarelle-d421dd8722a96a494dfaa8e9bd12ff5e.jpg";